export const findInsertionPosition = (arr: number[], target: number): number => {
  const index = arr.findIndex((item) => item >= target);

  return index === -1 ? arr.length + 1 : index;
};
